module.exports = __webpack_public_path__ + "static/quiltedrosebunny-8a97aa0df0bb3bf0649db2d0ced35ba2.jpeg";